module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert",
    class: _vm.success === true ? 'alert-success' : 'alert-danger'
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    attrs: {
      "id": "spinner"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-lg",
    class: _vm.spin === true ? 'fa-spin' : ''
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-322885e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = 584
// module chunks = 2